export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  tags: string[];
  rating: number;
  views: number;
  description: string;
  status: '连载中' | '已完结';
  updateTime: string;
  chapters: number;
}

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '我独自升级',
    author: 'Chugong / Dubu',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20solo%20leveling%20dark%20fantasy%20character%20with%20purple%20glowing%20eyes%20holding%20dagger%2C%20mysterious%20atmosphere%2C%20dramatic%20lighting%2C%20comic%20cover%20style%2C%20illustration%20with%20detailed%20linework%2C%20anime%20inspired%20art%2C%20clean%20background%20with%20subtle%20gradient&width=400&height=560&seq=comic-solo-leveling&orientation=portrait',
    category: '奇幻冒险',
    tags: ['热血', '战斗', '升级', '异能'],
    rating: 4.9,
    views: 15200000,
    description: '十年前，世界各地出现了连接异次元与现实的"传送门"，而觉醒了特殊能力、被称为"猎人"的人们也随之出现。作为最弱的E级猎人成振宇，在一次几乎全军覆没的地下城探险中，他独自被留在了最深处。在濒死之际，他面前出现了一个神秘的任务窗口...',
    status: '连载中',
    updateTime: '2026-08-03',
    chapters: 189
  },
  {
    id: 'comic-2',
    title: '女神降临',
    author: '喵喵',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20girl%20with%20long%20hair%20applying%20makeup%20in%20front%20of%20mirror%2C%20makeup%20transformation%20theme%2C%20soft%20pink%20and%20warm%20tones%2C%20romantic%20school%20life%20setting%2C%20anime%20style%20illustration%2C%20gentle%20lighting%2C%20clean%20minimal%20background&width=400&height=560&seq=comic-goddess-desc&orientation=portrait',
    category: '恋爱校园',
    tags: ['美妆', '校园', '恋爱', '逆袭'],
    rating: 4.7,
    views: 12800000,
    description: '因外貌被霸凌的任朱静，通过化妆实现了惊人的转变，转学后成为全校公认的女神。然而她一直活在素颜被人发现的恐惧中。直到某天，全校唯一知道她素颜的秘密的校草李修浩出现了...',
    status: '已完结',
    updateTime: '2026-06-15',
    chapters: 224
  },
  {
    id: 'comic-3',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20omniscient%20reader%20viewpoint%20protagonist%20with%20glasses%20and%20coat%20standing%20in%20apocalyptic%20cityscape%2C%20dramatic%20composition%2C%20dystopian%20background%20with%20ruins%2C%20sci-fi%20fantasy%20elements%2C%20detailed%20illustration%20style%2C%20dynamic%20pose&width=400&height=560&seq=comic-omniscient&orientation=portrait',
    category: '奇幻冒险',
    tags: ['末世', '系统', '穿越', '智斗'],
    rating: 4.9,
    views: 14300000,
    description: '金独子是一名普通的上班族，他唯一的兴趣就是阅读网络小说《在灭亡的世界中存活的三种方法》。当这部连载了十年的小说终于完结的那一刻，小说中的世界竟然成为了现实。作为唯一知道这个世界结局的人，金独子开始了他的生存之旅。',
    status: '连载中',
    updateTime: '2026-08-02',
    chapters: 210
  },
  {
    id: 'comic-4',
    title: '公爵的契约未婚妻',
    author: 'Milcha / Whale',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20fantasy%20manhwa%20elegant%20noblewoman%20in%20beautiful%20gown%20with%20blonde%20hair%2C%20standing%20with%20duke%20in%20royal%20palace%20setting%2C%20warm%20golden%20lighting%2C%20romantic%20atmosphere%2C%20beautiful%20anime%20art%20style%2C%20soft%20pastel%20background&width=400&height=560&seq=comic-duke-fiance&orientation=portrait',
    category: '恋爱校园',
    tags: ['宫廷', '转生', '契约婚姻', '甜宠'],
    rating: 4.8,
    views: 9800000,
    description: '平凡的大学生在一次意外中穿越到了小说世界，成为了即将被未婚夫毒杀的配角。为了活命，她与帝国最有权势的公爵签订了契约婚姻。原本以为只是互相利用的关系，却不知何时开始，两人之间的感情悄然发生了变化...',
    status: '已完结',
    updateTime: '2026-05-20',
    chapters: 153
  },
  {
    id: 'comic-5',
    title: '神之塔',
    author: 'SIU',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20tower%20of%20god%20mysterious%20boy%20climbing%20an%20endless%20tower%2C%20fantasy%20world%20with%20floating%20platforms%2C%20epic%20adventure%20theme%2C%20vibrant%20anime%20illustration%20style%2C%20dramatic%20perspective%2C%20mysterious%20blue%20and%20gold%20color%20scheme%2C%20clean%20background&width=400&height=560&seq=comic-tower-god&orientation=portrait',
    category: '奇幻冒险',
    tags: ['冒险', '塔', '友情', '神秘'],
    rating: 4.8,
    views: 18500000,
    description: '二十五夜为了追寻唯一的朋友蕾哈尔，闯入了传说中的神之塔。这座塔的每一层都是一个独立的世界，只有通过试炼才能向上攀登。在这里他结识了许多伙伴，也面临着无数挑战。塔顶究竟有什么？蕾哈尔为什么要离开他？答案只有在塔顶才能找到。',
    status: '连载中',
    updateTime: '2026-08-04',
    chapters: 600
  },
  {
    id: 'comic-6',
    title: '看脸时代',
    author: '朴泰俊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20lookism%20handsome%20man%20with%20split%20personality%20transformation%2C%20dual%20identity%20concept%2C%20modern%20school%20setting%2C%20dramatic%20contrast%20lighting%2C%20urban%20youth%20culture%2C%20anime%20illustration%20style%2C%20dynamic%20composition%2C%20clean%20background&width=400&height=560&seq=comic-lookism&orientation=portrait',
    category: '剧情悬疑',
    tags: ['校园', '双面人生', '格斗', '社会'],
    rating: 4.6,
    views: 11200000,
    description: '因外貌被霸凌的朴亨硕，某天醒来发现自己拥有了一个完美的身体。从此他开始了白天是帅气型男、晚上变回原来模样的双面生活。在这个过程中，他逐渐认识到外表主义社会的残酷现实，并用自己的方式与不公平的世界抗争。',
    status: '连载中',
    updateTime: '2026-08-01',
    chapters: 467
  },
  {
    id: 'comic-7',
    title: '入坑',
    author: 'ZICO / YoungChan',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20intense%20scene%20of%20a%20man%20and%20woman%20facing%20each%20other%20with%20suspenseful%20expressions%2C%20dark%20atmosphere%2C%20psychological%20tension%2C%20urban%20night%20setting%2C%20dramatic%20anime%20style%2C%20mysterious%20mood%2C%20clean%20background%20with%20dark%20gradient&width=400&height=560&seq=comic-trapped&orientation=portrait',
    category: '剧情悬疑',
    tags: ['悬疑', '心理', '犯罪', '反转'],
    rating: 4.7,
    views: 7600000,
    description: '尹秀是一名普通的大学生，某天晚上她在回家路上遇到了一个陌生男人。这个看似偶然的相遇，却将她卷入了一场精心策划的陷阱。随着真相一步步揭开，她发现身边的人都不像表面看起来那么简单...',
    status: '已完结',
    updateTime: '2026-04-10',
    chapters: 89
  },
  {
    id: 'comic-8',
    title: '剑尊归来',
    author: 'LICO / 红桃',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20sword%20master%20with%20flowing%20robes%20holding%20glowing%20sword%2C%20ancient%20Korean%20palace%20setting%2C%20wuxia%20theme%2C%20dramatic%20wind%20effect%2C%20beautiful%20illustration%20with%20ink%20wash%20style%2C%20golden%20and%20crimson%20accent%20colors%2C%20clean%20artistic%20background&width=400&height=560&seq=comic-sword-master&orientation=portrait',
    category: '武侠古风',
    tags: ['武侠', '重生', '复仇', '江湖'],
    rating: 4.8,
    views: 10500000,
    description: '一代剑尊陈鹤年被最信任的弟子背叛而亡。当他再次睁开眼睛，竟发现自己回到了五十年前，变成了一个落魄贵族家的废柴少爷。带着前世的记忆和绝世武功，他誓要改写命运，让所有背叛者付出代价。',
    status: '连载中',
    updateTime: '2026-08-03',
    chapters: 156
  },
  {
    id: 'comic-9',
    title: '甜蜜家园',
    author: '金坎比 / 黄英灿',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20manhwa%20sweet%20home%20apocalyptic%20survival%20scene%20with%20monsters%20and%20survivors%2C%20dark%20atmosphere%2C%20apartment%20building%20setting%2C%20thriller%20theme%2C%20detailed%20monster%20design%2C%20anime%20horror%20style%2C%20dramatic%20lighting%2C%20intense%20mood&width=400&height=560&seq=comic-sweet-home&orientation=portrait',
    category: '剧情悬疑',
    tags: ['末世', '怪物', '生存', '人性'],
    rating: 4.8,
    views: 16200000,
    description: '车贤秀在失去家人后搬进了一栋破旧的公寓楼，准备结束自己的生命。但世界突然发生了异变，人们开始变成可怕的怪物。在这栋与外界隔绝的公寓楼里，幸存者们必须团结起来对抗怪物，同时也要面对人性最黑暗的一面。',
    status: '已完结',
    updateTime: '2026-03-28',
    chapters: 141
  },
  {
    id: 'comic-10',
    title: '我养育的S级',
    author: 'Seri / 已善',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20S-class%20hunter%20young%20boy%20with%20supernatural%20powers%2C%20protective%20older%20sister%20figure%2C%20magical%20effects%2C%20modern%20fantasy%20setting%2C%20warm%20family%20bond%20theme%2C%20beautiful%20anime%20illustration%2C%20soft%20golden%20light%2C%20clean%20background&width=400&height=560&seq=comic-s-class&orientation=portrait',
    category: '奇幻冒险',
    tags: ['异能', '亲子', '养成', '治愈'],
    rating: 4.7,
    views: 8900000,
    description: '在一个充满猎人和地下城的世界里，F级猎人韩宥珍在一次任务中意外救下了一个神秘的小男孩。这个男孩拥有S级的潜力，但需要有人引导他成长。宥珍决定收养这个孩子，一边经营自己的猎人生涯，一边培养这个未来的S级强者。',
    status: '连载中',
    updateTime: '2026-08-04',
    chapters: 134
  },
  {
    id: 'comic-11',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20beautiful%20princess%20with%20long%20pink%20hair%20in%20elegant%20dress%2C%20royal%20palace%20setting%2C%20father-daughter%20theme%2C%20warm%20and%20touching%20atmosphere%2C%20soft%20fairytale%20illustration%20style%2C%20sparkling%20light%20effects%2C%20dreamy%20background&width=400&height=560&seq=comic-princess&orientation=portrait',
    category: '恋爱校园',
    tags: ['宫廷', '父女', '穿越', '治愈'],
    rating: 4.8,
    views: 13700000,
    description: '醒来后发现自己穿越成了小说中注定要被亲生父亲杀死的公主。为了改变自己的悲惨命运，雅典娜决定主动接近那位冷酷无情的皇帝父亲。然而随着相处，她发现这位父亲似乎并不像小说中描写的那样铁石心肠...',
    status: '已完结',
    updateTime: '2026-02-14',
    chapters: 125
  },
  {
    id: 'comic-12',
    title: '魔道祖师',
    author: '墨香铜臭 / 毛团小剑剑',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20fantasy%20manhua%20cultivator%20in%20black%20robes%20playing%20flute%2C%20mysterious%20atmosphere%2C%20ink%20wash%20painting%20style%2C%20floating%20spiritual%20energy%2C%20beautiful%20detailed%20character%20design%2C%20traditional%20Chinese%20aesthetic%2C%20dark%20and%20elegant%20composition%2C%20clean%20artistic%20background&width=400&height=560&seq=comic-mdzs&orientation=portrait',
    category: '武侠古风',
    tags: ['修仙', '古风', '悬疑', '经典'],
    rating: 4.9,
    views: 21000000,
    description: '十三年后，魏无羡被强行献舍重生。曾经令人闻风丧胆的夷陵老祖，如今回到了这个早已物是人非的修真世界。与昔日故人蓝忘机重逢后，两人一起追查一具被分尸的神秘尸体的来历，逐渐揭开了一个个惊天秘密。',
    status: '已完结',
    updateTime: '2026-01-30',
    chapters: 256
  }
];

export const featuredComicIds = ['comic-1', 'comic-3', 'comic-5', 'comic-8', 'comic-2', 'comic-6'];
export const trendingComicIds = ['comic-5', 'comic-1', 'comic-4', 'comic-9', 'comic-7', 'comic-2', 'comic-11', 'comic-8', 'comic-3', 'comic-10'];
export const latestComicIds = ['comic-5', 'comic-10', 'comic-1', 'comic-6', 'comic-8', 'comic-3'];